import ApiResponse from "../ApiResponse";

export enum UserRoleResponse {
    Admin = 'Admin',
    Employee = 'Employee',
}
export default interface GetUserRoleResponse extends ApiResponse<UserRoleResponse> { }